import * as S from "./styles";
import { ButtonProps } from "../../../../components/New/Button";

export function SignInButton(props: ButtonProps) {
  return <S.SignInButton {...props} width="100%" height="3.5rem" />;
}
